module.exports = __webpack_public_path__ + "img/fondo-misiones.34306362.gif";